export const BILLING_MAXIMUN_VALUE = 9999999999;

export const INTEGER_MAXIMUN_VALUE = 2147483647;